export default __webpack_public_path__ + "static/hero-illustration-82419bb3a3f2525e2718d2bc7e094f91.svg";